import script from "./SurveyFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyFormView.vue?vue&type=script&setup=true&lang=js"

import "./SurveyFormView.vue?vue&type=style&index=0&id=0b24991f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b24991f"]])

export default __exports__